import { useTranslation } from "react-i18next";

import type { ErrorFallbackProps } from "./ErrorBoundary";

import { ErrorDetail } from "./ErrorDetail";

export function RenderError({ errorDetail, error, errorInfo, ownerStack }: ErrorFallbackProps) {
  const { t } = useTranslation("errors");
  return (
    <div className="rounded-sm border border-red-200 bg-red-100 p-4 font-disinterest text-red-500">
      <p>{t("unexpected-error")}</p>
      {!!errorDetail && <ErrorDetail error={errorDetail} />}

      {import.meta.env.DEV ? (
        <details>
          <summary>{t("more-info")}</summary>
          {errorDetail && (
            <pre>
              <code>{JSON.stringify(errorDetail, null, 2)}</code>
            </pre>
          )}
          <pre>
            <code>{error?.toString()}</code>
          </pre>
          {!!errorInfo && (
            <pre>
              <code>{errorInfo?.componentStack}</code>
            </pre>
          )}
          {!!ownerStack && (
            <pre>
              <code>{ownerStack}</code>
            </pre>
          )}
        </details>
      ) : (
        <details>
          <summary>{t("more-info")}</summary>
          <pre>
            <code>{error?.toString()}</code>
          </pre>
        </details>
      )}
    </div>
  );
}
